var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[(!_vm.test)?_c('ui-setting'):_vm._e(),(_vm.test)?_c('async-component',{attrs:{"url":"http://localhost:8081/PluginDemo.js"},on:{"execute-axios":_vm.executeAxios}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }